module.exports = __webpack_public_path__ + "2f847810090ed711b72af3e89efcaf05.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C0000AR9Z.png
// module id = 1710
// module chunks = 0